module.exports = __webpack_public_path__ + "partylineManage/img/ConferenceDark.4628361b.png";